const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      services: "Hizmetler",
      blog: "Blog",
      contact: "İletişim",
      appointment: "Randevu Al",
      articles: "Makaleler",
    },
    hero: {
      title: "Avukat Samet Öztürk",
      subtitle: "Hukuki süreçlerinizde güvenilir ve profesyonel çözüm ortağınız",
      cta_appointment: "Randevu Al",
      cta_contact: "İletişime Geç",
    },
    services: {
      title: "Hizmet Alanlarımız",
      subtitle: "Geniş kapsamlı hukuki danışmanlık ve dava takibi hizmetleri",
      detail: "Detaylı Bilgi",
    },
    about: {
      title: "Hakkımızda",
      subtitle: "Av. Samet Öztürk",
      bio: "Dokuz Eylül Üniversitesi Hukuk Fakültesi mezunu olan Av. Samet Öztürk, yaklaşık 3 yıllık mesleki deneyimi ile müvekkillerine güvenilir, çözüm odaklı ve profesyonel hukuki danışmanlık hizmeti sunmaktadır. Hukukun üstünlüğü, etik değerler ve müvekkil memnuniyeti ilkelerini esas alan Av. Öztürk; her dosyayı titizlikle değerlendirerek, müvekkillerinin hak ve menfaatlerini en etkin şekilde korumayı amaçlamaktadır. Güncel mevzuatı yakından takip eden ve her hukuki sürece stratejik bir bakış açısıyla yaklaşan Av. Öztürk, şeffaf iletişim anlayışıyla müvekkillerini sürecin her aşamasında bilgilendirmektedir. Başta ceza hukuku, aile hukuku, iş hukuku ve ticaret hukuku olmak üzere çeşitli hukuk alanlarında hizmet vermekte; bireysel ve kurumsal müvekkillerine etkili, güvenilir ve sonuç odaklı hukuki çözümler sunmaktadır.",
      education: "Eğitim",
      education_detail: "Dokuz Eylül Üniversitesi Hukuk Fakültesi",
      expertise: "Uzmanlık Alanları",
      experience: "3+ Yıl Deneyim",
    },
    stats: {
      cases: "Kazanılan Dava",
      clients: "Mutlu Müvekkil",
      experience: "Yıl Deneyim",
      success_rate: "Başarı Oranı",
    },
    testimonials: {
      title: "Müvekkil Yorumları",
      items: [
        { name: "Mehmet Yılmaz", role: "İş İnsanı", text: "Samet Bey sayesinde davamı kazandım. Profesyonel ve güvenilir bir avukat. Kesinlikle tavsiye ederim." },
        { name: "Ayşe Demir", role: "Öğretmen", text: "Boşanma sürecimde bana büyük destek oldu. Hassas ve anlayışlı yaklaşımı ile bu zor süreci kolaylaştırdı." },
        { name: "Ali Kara", role: "Mühendis", text: "İş hukuku konusunda çok bilgili. Tazminat davamda haklarımı en iyi şekilde savundu." },
      ],
    },
    blog: {
      title: "Blog Yazılarımız",
      subtitle: "Hukuki gündem ve bilgilendirme yazıları",
      read_more: "Devamını Oku",
      all_posts: "Tüm Yazılar",
    },
    contact: {
      title: "İletişim",
      subtitle: "Bizimle iletişime geçin",
      name: "Adınız Soyadınız",
      email: "E-posta",
      phone: "Telefon",
      subject: "Konu",
      message: "Mesajınız",
      send: "Gönder",
      success: "Mesajınız başarıyla gönderildi!",
      address: "Karapınar Mah. 1128. Sok. No:7 Kat:2 D:4, Altınordu, Ordu",
      phone_number: "+90 506 385 93 52",
      email_address: "av.sametozturk1@gmail.com",
    },
    appointment: {
      title: "Online Randevu",
      subtitle: "Size uygun tarih ve saati seçin",
      select_date: "Tarih Seçin",
      select_time: "Saat Seçin",
      your_info: "Bilgileriniz",
      name: "Adınız Soyadınız",
      email: "E-posta",
      phone: "Telefon",
      subject: "Randevu Konusu",
      message: "Ek Bilgi (İsteğe bağlı)",
      book: "Randevu Oluştur",
      success: "Randevunuz başarıyla oluşturuldu!",
      no_slots: "Bu tarihte müsait saat bulunmamaktadır.",
      subjects: ["Ceza Hukuku", "Aile Hukuku", "İş Hukuku", "Ticaret Hukuku", "İcra Hukuku", "Gayrimenkul", "Diğer"],
    },
    common: {
      loading: "Yükleniyor...",
      error: "Bir hata oluştu",
      success: "Başarılı!",
    },
    footer: {
      description: "Hukuki süreçlerinizde yanınızdayız. Profesyonel ve güvenilir avukatlık hizmeti.",
      quick_links: "Hızlı Erişim",
      services: "Hizmetlerimiz",
      contact_info: "İletişim Bilgileri",
      rights: "Tüm hakları saklıdır.",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Şartları",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      blog: "Blog",
      contact: "Contact",
      appointment: "Book Appointment",
      articles: "Articles",
    },
    hero: {
      title: "Attorney Samet Öztürk",
      subtitle: "Your reliable and professional partner in legal processes",
      cta_appointment: "Book Appointment",
      cta_contact: "Contact Us",
    },
    services: {
      title: "Our Practice Areas",
      subtitle: "Comprehensive legal consultancy and litigation services",
      detail: "Learn More",
    },
    about: {
      title: "About Us",
      subtitle: "Atty. Samet Öztürk",
      bio: "Attorney Samet Öztürk, a graduate of Dokuz Eylül University Faculty of Law, provides reliable, solution-oriented and professional legal consultancy services to his clients with approximately 3 years of professional experience. Based on the principles of the rule of law, ethical values and client satisfaction, Atty. Öztürk aims to protect the rights and interests of his clients in the most effective way by meticulously evaluating each case. Closely following current legislation and approaching each legal process with a strategic perspective, Atty. Öztürk informs his clients at every stage of the process with a transparent communication approach.",
      education: "Education",
      education_detail: "Dokuz Eylül University Faculty of Law",
      expertise: "Areas of Expertise",
      experience: "3+ Years Experience",
    },
    stats: {
      cases: "Cases Won",
      clients: "Happy Clients",
      experience: "Years Experience",
      success_rate: "Success Rate",
    },
    testimonials: {
      title: "Client Testimonials",
      items: [
        { name: "Mehmet Yılmaz", role: "Businessman", text: "Thanks to Mr. Samet, I won my case. A professional and reliable lawyer. I definitely recommend." },
        { name: "Ayşe Demir", role: "Teacher", text: "He gave me great support during my divorce process. His sensitive and understanding approach made this difficult process easier." },
        { name: "Ali Kara", role: "Engineer", text: "Very knowledgeable in labor law. He defended my rights in the best way in my compensation case." },
      ],
    },
    blog: {
      title: "Our Blog",
      subtitle: "Legal agenda and informative articles",
      read_more: "Read More",
      all_posts: "All Posts",
    },
    contact: {
      title: "Contact",
      subtitle: "Get in touch with us",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Your Message",
      send: "Send",
      success: "Your message has been sent successfully!",
      address: "Karapınar Mah. 1128. Sok. No:7 Kat:2 D:4, Altınordu, Ordu",
      phone_number: "+90 506 385 93 52",
      email_address: "av.sametozturk1@gmail.com",
    },
    appointment: {
      title: "Online Appointment",
      subtitle: "Select a suitable date and time",
      select_date: "Select Date",
      select_time: "Select Time",
      your_info: "Your Information",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      subject: "Appointment Subject",
      message: "Additional Info (Optional)",
      book: "Book Appointment",
      success: "Your appointment has been created successfully!",
      no_slots: "No available slots for this date.",
      subjects: ["Criminal Law", "Family Law", "Labor Law", "Commercial Law", "Enforcement Law", "Real Estate", "Other"],
    },
    common: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Success!",
    },
    footer: {
      description: "We are with you in your legal processes. Professional and reliable legal services.",
      quick_links: "Quick Links",
      services: "Our Services",
      contact_info: "Contact Information",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
    },
  },
};

export default translations;
